import { formatInTimeZone } from 'date-fns-tz'

// Invariant for all user-facing dates: render in the ranch's configured
// timezone, not the browser's local zone. Store in UTC on the wire. A
// manager reviewing a report from a city in a different timezone than the
// ranch should see timestamps that line up with what happened on the farm.
//
// `input` may be a JS Date, an ISO string, or a YYYY-MM-DD date-only string.
// `timezone` falls back to UTC when the ranch config hasn't loaded yet.
const DEFAULT_TZ = 'UTC'

export function renderDate(input, timezone = DEFAULT_TZ, fmt = 'MMM d, yyyy') {
  if (!input) return ''
  const date = typeof input === 'string' ? new Date(input) : input
  if (Number.isNaN(date.getTime())) return ''
  return formatInTimeZone(date, timezone || DEFAULT_TZ, fmt)
}

export function renderDateTime(input, timezone = DEFAULT_TZ, fmt = 'MMM d, yyyy HH:mm zzz') {
  return renderDate(input, timezone, fmt)
}

export function renderTime(input, timezone = DEFAULT_TZ, fmt = 'HH:mm zzz') {
  return renderDate(input, timezone, fmt)
}
